import { EquipmentRequiringInstruction, GymTypes, SmallBodyGroupType } from 'fitbeat.models';
import { getEquipmentResistanceStrategy } from '../../equipment-weight-recommendations/EquipmentResistanceStrategy';
import { IResistanceStrategy } from '../../workouthydration';
import { IAnswerMap, IWizardStep, IWizardStepState, WizardManager } from '../wizardManager';
import { ISelectDumbbellWeight, ISelectWeight, WeightAsessmentSteps } from './config';

export interface IStrengthAssessmentAnswer {
  ratio: number;
  primaryMuscleMover: SmallBodyGroupType;
  userWeight: number;
}
export interface IStrengthAssessmentUserAnswer {
  primaryMuscleMover: SmallBodyGroupType;
  userWeight: number;
  equipmentRequiringInstruction?: EquipmentRequiringInstruction;
}

export class StrengthAssessmentWizard extends WizardManager<WeightAsessmentSteps, IStrengthAssessmentAnswer> {
  private resistanceStrategy: IResistanceStrategy;
  public answer(
    wizardState: IWizardStepState<
      WeightAsessmentSteps,
      IStrengthAssessmentAnswer
    >,
    answer: IStrengthAssessmentUserAnswer,
  ): IAnswerMap<IStrengthAssessmentAnswer> {
    const { currentStep, answers } = wizardState;
    const step = currentStep as IWizardStep<ISelectWeight|ISelectDumbbellWeight>;
    if (!currentStep) {
      throw new Error(
        'Current step in strength assessment is required as a paramarer when answering',
      );
    }
    const { userWeight, equipmentRequiringInstruction } = answer;
    const { equipmentWeightLevel, primaryMuscleMover } = step.config;
    const strengthRatioForMuscleGroup =
      this.resistanceStrategy.calculateUserStrengthRatio(
        userWeight,
        equipmentWeightLevel,
        equipmentRequiringInstruction,
      );
    answers[currentStep.questionId] = {
      ratio: strengthRatioForMuscleGroup,
      userWeight,
      primaryMuscleMover,
    };
    return answers;
  }
  public setResistanceStrategy(equipmentRequiringInstruction: EquipmentRequiringInstruction, gymType: GymTypes) {
    this.resistanceStrategy = getEquipmentResistanceStrategy(
      gymType,
      equipmentRequiringInstruction,
    );
   }
}
